const componentsThemeMap = {
  default: {
    background: 'background',
    foreground: 'foreground',
    foregroundSecondary: 'foregroundMuted',
    foregroundInlineLink: 'blue60',
    backgroundAlternate: 'backgroundAlternate',
    borderLine: 'line',
    primary: 'primary'
  },
  dark: {
    background: 'foreground',
    foreground: 'background',
    foregroundSecondary: 'background',
    foregroundInlineLink: 'blue30',
    backgroundAlternate: 'foregroundMuted',
    backgroundHover: 'primary',
    borderLine: 'background',
    primary: 'primary'
  },
  darkwash: {
    background: 'gray90',
    foreground: 'background',
    foregroundSecondary: 'background',
    foregroundInlineLink: 'blue30',
    backgroundAlternate: 'foregroundMuted',
    backgroundHover: 'primary',
    borderLine: 'background',
    primary: 'primary'
  },
  subtle: {
    background: 'backgroundAlternate',
    foreground: 'foreground',
    foregroundSecondary: 'foregroundMuted',
    foregroundInlineLink: 'blue60',
    backgroundAlternate: 'background',
    borderLine: 'foregroundMuted',
    primary: 'primary'
  },
  wash: {
    background: 'primaryWash',
    foreground: 'foreground',
    foregroundSecondary: 'foregroundMuted',
    foregroundInlineLink: 'blue60',
    backgroundAlternate: 'background',
    backgroundHover: 'backgroundAlternate',
    borderLine: 'foregroundMuted',
    primary: 'primary'
  },
  primary: {
    background: 'primary',
    foreground: 'background',
    foregroundSecondary: 'backgroundAlternate',
    foregroundInlineLink: 'gray0',
    borderLine: 'background',
    backgroundAlternate: 'foreground',
    backgroundHover: 'line',
    primary: 'background'
  }
};
const camelToKebabCase = str => str.replace(/[A-Z]/g, s => `-${s.toLowerCase()}`);
const colorToVariable = color => `var(--${camelToKebabCase(color)})`;
const formatCustomColor = value => `rgb(var(--${value}))`;
export { colorToVariable, componentsThemeMap, formatCustomColor };
//# sourceMappingURL=componentsThemeMap.js.map
